import React, { useState, useEffect, useRef } from "react";
import "./LoadingWithProgress.css";

const LoadingWithProgress = ({ isComplete = false, onComplete }) => {
	const [progress, setProgress] = useState(0);
	const progressRef = useRef(0);
	const onCompleteRef = useRef(onComplete);

	useEffect(() => {
		onCompleteRef.current = onComplete;
	}, [onComplete]);

	useEffect(() => {
		progressRef.current = progress;
	}, [progress]);

	useEffect(() => {
		if (isComplete) return;

		const RATE = 75 / 270;
		const startTime = performance.now();

		const interval = setInterval(() => {
			const elapsed = (performance.now() - startTime) / 1000;
			setProgress(Math.min(elapsed * RATE, 75));
		}, 1000);

		return () => clearInterval(interval);
	}, [isComplete]);

	useEffect(() => {
		if (!isComplete) return;

		const startProgress = progressRef.current;
		const duration = startProgress < 75 ? 5000 : 3000;
		const startTime = performance.now();

		const raf = requestAnimationFrame(function animate(time) {
			const elapsed = time - startTime;
			const t = Math.min(elapsed / duration, 1);
			setProgress(startProgress + (100 - startProgress) * t);

			if (t < 1) {
				requestAnimationFrame(animate);
			} else {
				onCompleteRef.current?.();
			}
		});

		return () => cancelAnimationFrame(raf);
	}, [isComplete]);

	return (
		<div className="loader-overlay-p">
			<img src="/kntu-logo.png" alt="logo" className="loader-p" />
			<div className="loading-text-p"></div>
			<div className="progress-container-p">
				<div
					className="progress-bar-p"
					style={{ width: `${progress}%`, transition: isComplete ? 'none' : 'width 0.3s ease-out' }}
				></div>
			</div>
			<p className="progress-percent">{Math.round(progress)}%</p>
		</div>
	);
};

export default LoadingWithProgress;
